import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import IdleTimerLogoutModal from "./idleTimeoutPopUp"; // Adjust the import path as needed
import { useSelector } from "react-redux";

const IdleTimeout = () => {
  const dashboardDetails = useSelector((state) => state.Dashboard);
  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const timerRef = useRef(null);
  const popupTimerRef = useRef(null);
  const autoLogoutTimerRef = useRef(null);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
    console.log("User logged out");

    // Clear all timers
    clearTimeout(timerRef.current);
    clearTimeout(popupTimerRef.current);
    clearTimeout(autoLogoutTimerRef.current);
    setShowPopup(false);
  };

  const handleKeepSession = () => {
    setShowPopup(false);
    resetTimers(); // Reset timers when user chooses to stay logged in
  };

  const handleEndSession = () => {
    setShowPopup(false);
    handleLogout();
  };

  const resetTimers = () => {
    clearTimeout(timerRef.current);
    clearTimeout(popupTimerRef.current);
    clearTimeout(autoLogoutTimerRef.current);

    // Show popup after 8 minutes of inactivity
    popupTimerRef.current = setTimeout(() => {
      setShowPopup(true);

      // If no action taken, logout after 2 more minutes (total 10 mins)
      autoLogoutTimerRef.current = setTimeout(() => {
        handleLogout();
      }, 2 * 60 * 1000); // 2 minutes
    }, 8 * 60 * 1000); // 8 minutes

    // Auto-logout at exactly 10 minutes
    timerRef.current = setTimeout(() => {
      handleLogout();
    }, 10 * 60 * 1000); // 10 minutes
  };

  useEffect(() => {
    const userId = dashboardDetails?.userId;

    if (userId && userId !== "null") {
      resetTimers(); // Start timers when user is active

      const resetOnActivity = debounce(() => {
        resetTimers(); // Reset timers on user activity
      }, 200);

      window.addEventListener("mousemove", resetOnActivity);
      window.addEventListener("keydown", resetOnActivity);

      return () => {
        clearTimeout(timerRef.current);
        clearTimeout(popupTimerRef.current);
        clearTimeout(autoLogoutTimerRef.current);
        window.removeEventListener("mousemove", resetOnActivity);
        window.removeEventListener("keydown", resetOnActivity);
      };
    } else {
      if (window.location.pathname === "/terms-and-conditions") {
        return;
      }
      else if (window.location.pathname === "/privacy-policy") {
        return;
      }
      else if (window.location.pathname === "/risk-and-disclosure") {
        return;
      }

      handleLogout(); // If no user session, log out immediately
    }
  }, [dashboardDetails?.userId]);

  return (
    <IdleTimerLogoutModal
      isOpen={showPopup}
      onClose={handleKeepSession}
      onConfirm={handleEndSession}
    />
  );
};

// Debounce function to optimize event handling
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

export default IdleTimeout;
